// Parent class for vendor and customer
export class Contact {
  #id: string;
  #isUpserted: boolean;
  #shouldBeUpserted: boolean;
  #invoices: string[];

  constructor(id: string, invoiceId?: string, isUpserted?: boolean, shouldBeUpserted?: boolean) {
    this.#id = id;
    this.#isUpserted = !!isUpserted;
    this.#shouldBeUpserted = !!shouldBeUpserted;
    this.#invoices = invoiceId ? [invoiceId] : [];
  }

  addInvoiceId(invoiceId: string) {
    this.#invoices.push(invoiceId);
  }
  addInvoiceIds(invoiceIds: string[]) {
    this.#invoices.push(...invoiceIds);
  }

  get id(): string {
    return this.#id;
  }
  set id(value: string) {
    this.#id = value;
  }
  get isUpserted() {
    return this.#isUpserted;
  }
  set isUpserted(value: boolean) {
    this.#isUpserted = value;
  }
  get shouldBeUpserted() {
    return this.#shouldBeUpserted;
  }
  set shouldBeUpserted(value: boolean) {
    this.#shouldBeUpserted = value;
  }
  get invoices(): string[] {
    return this.#invoices;
  }
  set invoices(value: string[]) {
    this.#invoices = value;
  }
}
